export default __webpack_public_path__ + "static/media/favicon.4fe75d5f.ico";